import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
const StatusInProgressIcon = (t0)=>{
    const $ = c(7);
    const { width, height, color } = t0;
    let t1;
    let t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ jsx("rect", {
            width: "16",
            height: "16",
            rx: "8"
        });
        t2 = /*#__PURE__*/ jsx("path", {
            d: "M8 4.5C8.276 4.5 8.5 4.724 8.5 5V9.5C8.5 9.776 8.276 10 8 10C7.724 10 7.5 9.776 7.5 9.5V5C7.5 4.724 7.724 4.5 8 4.5Z",
            fill: "white"
        });
        t3 = /*#__PURE__*/ jsx("path", {
            d: "M8 12C8.414 12 8.75 11.664 8.75 11.25C8.75 10.836 8.414 10.5 8 10.5C7.586 10.5 7.25 10.836 7.25 11.25C7.25 11.664 7.586 12 8 12Z",
            fill: "white"
        });
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
    } else {
        t1 = $[0];
        t2 = $[1];
        t3 = $[2];
    }
    let t4;
    if ($[3] !== color || $[4] !== height || $[5] !== width) {
        t4 = /*#__PURE__*/ jsxs("svg", {
            width: width,
            height: height,
            fill: color,
            viewBox: "0 0 16 16",
            children: [
                t1,
                t2,
                t3
            ]
        });
        $[3] = color;
        $[4] = height;
        $[5] = width;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
};
export { StatusInProgressIcon };
